import { Link } from 'react-router-dom';
import type { Env } from '../types';

interface Props {
  env: Env;
  title: string;
  subtitle?: string;
}

// Common header for env detail pages — breadcrumb back to the env overview
// plus page title. Kept separate so the overview stays visually clean.
export default function DetailHeader({ env, title, subtitle }: Props) {
  return (
    <div className="detail-header">
      <nav className="breadcrumb" aria-label="Breadcrumb">
        <Link to={`/${env}`}>← {env.toUpperCase()} overview</Link>
      </nav>
      <h2>{title}</h2>
      {subtitle && <p>{subtitle}</p>}
    </div>
  );
}
